import InterfaceParameters from './interface_parameters.vue';

export default InterfaceParameters;
